/* ════════════════════════════════════════════════
   FITFARM PULSSI — Seed-pohjainen deterministinen
   datavirta-elementti etusivulle
   ════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── Deterministinen satunnaislukugeneraattori (Mulberry32) ─── */
  function mulberry32(seed) {
    return function() {
      seed |= 0; seed = seed + 0x6D2B79F5 | 0;
      var t = Math.imul(seed ^ seed >>> 15, 1 | seed);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }

  function dateSeed(date) {
    var d = date || new Date();
    return d.getFullYear() * 10000 + (d.getMonth()+1) * 100 + d.getDate();
  }

  /* ─── Kaupungit (60+ suomalaista kaupunkia, Kotus-tarkistetut taivutukset) ─── */
  var cities = [
    {loc:'Helsingissä'},{loc:'Espoossa'},{loc:'Tampereella'},{loc:'Vantaalla'},
    {loc:'Oulussa'},{loc:'Turussa'},{loc:'Jyväskylässä'},{loc:'Lahdessa'},
    {loc:'Kuopiossa'},{loc:'Kouvolassa'},{loc:'Porissa'},{loc:'Joensuussa'},
    {loc:'Lappeenrannassa'},{loc:'Hämeenlinnassa'},{loc:'Vaasassa'},{loc:'Seinäjoella'},
    {loc:'Rovaniemellä'},{loc:'Mikkelissä'},{loc:'Kotkassa'},{loc:'Salossa'},
    {loc:'Porvoossa'},{loc:'Kokkolassa'},{loc:'Hyvinkäällä'},{loc:'Lohjalla'},
    {loc:'Järvenpäässä'},{loc:'Raumalla'},{loc:'Kajaanissa'},{loc:'Keravalla'},
    {loc:'Savonlinnassa'},{loc:'Nokialla'},{loc:'Ylöjärvellä'},{loc:'Kangasalla'},
    {loc:'Riihimäellä'},{loc:'Iisalmessa'},{loc:'Varkaudessa'},{loc:'Raahessa'},
    {loc:'Hollolassa'},{loc:'Lempäälässä'},{loc:'Torniossa'},{loc:'Siilinjärvellä'},
    {loc:'Pietarsaaressa'},{loc:'Forssassa'},{loc:'Valkeakoskella'},{loc:'Jämsässä'},
    {loc:'Äänekoskella'},{loc:'Liedossa'},{loc:'Laukaassa'},{loc:'Liperissä'},
    {loc:'Kontiolahdella'},{loc:'Kempeleessä'},{loc:'Nurmijärvellä'},{loc:'Kirkkonummella'},
    {loc:'Tuusulassa'},{loc:'Sipoossa'},{loc:'Mäntsälässä'},{loc:'Vihdin Nummelassa'},
    {loc:'Heinolassa'},{loc:'Pieksämäellä'},{loc:'Kemissä'},{loc:'Sodankylässä'},
    {loc:'Inarissa'},{loc:'Kuusamossa'},{loc:'Sotkamossa'},{loc:'Loimaalla'}
  ];

  /* ─── Saavutusbadget (achievement badges) ─── */
  var badges = [
    'Ensimmäinen treeni','Treeniputki 3 pv','Treeniputki 7 pv','Treeniputki 14 pv','Treeniputki 30 pv',
    'Ensimmäinen aamupala','Aamupalakunkku','Aamupalakunkku 7 pv','Ruokapäiväkirja 7 pv','Ruokapäiväkirja 30 pv',
    'Vesimestari','Vesimestari 7 pv','Ensimmäinen punnitus','Punnitusputki 7 pv','Painotavoite saavutettu',
    'Ensimmäinen salitreeni','Salitreeni 10 kertaa','Salitreeni 25 kertaa','Kotitreeni 10 kertaa','HIIT-mestari',
    'Kävelyhaaste voitettu','10 000 askelta','Ensimmäinen ryhmäviesti','Tsemppaaja','Super-tsemppaaja',
    'Valmentajan suosikki','Viikkohaaste voitettu','Kuukausihaaste voitettu','Fiiliskuningas','Uniritari',
    'Välipalaekspertti','Ensimmäinen viikko täynnä','Puoliväli saavutettu','Valmennus suoritettu','Kalorilaskuri-pro',
    'Proteiinimestari','Smoothie-sankari','Salaattisankari','Askelmestari','Venyttelyvirtuoosi',
    'Iltarutiini','Aamurutiini','Hyvinvointipäiväkirja','Kehonkoostumus mitattu','Ennen ja jälkeen -kuva',
    'Reseptikokeilu','5 reseptiä kokeiltu','10 reseptiä kokeiltu','Treenimuistiinpano','Motivaatioviesti lähetetty'
  ];

  /* ─── Tapahtumapohjat ─── */
  var eventTemplates = [
    { icon:'fa-regular fa-person-running', color:'green', textFn: function(c){ return 'Treeni kirjattu ' + c; } },
    { icon:'fa-regular fa-heart-pulse', color:'red', textFn: function(c){ return 'Kotitreeni kirjattu ' + c; } },
    { icon:'fa-regular fa-dumbbell', color:'blue', textFn: function(c){ return 'Salitreeni kirjattu ' + c; } },
    { icon:'fa-regular fa-person-walking', color:'green', textFn: function(c){ return 'Kävelylenkki kirjattu ' + c; } },
    { icon:'fa-regular fa-stopwatch', color:'cyan', textFn: function(c){ return 'HIIT-treeni kirjattu ' + c; } },
    { icon:'fa-regular fa-utensils', color:'orange', textFn: function(c){ return 'Ateria kirjattu ' + c; } },
    { icon:'fa-regular fa-bowl-food', color:'orange', textFn: function(c){ return 'Ateria kirjattu ' + c; } },
    { icon:'fa-regular fa-mug-hot', color:'orange', textFn: function(c){ return 'Aamupala kirjattu ' + c; } },
    { icon:'fa-regular fa-apple-whole', color:'green', textFn: function(c){ return 'Välipala kirjattu ' + c; } },
    { icon:'fa-regular fa-weight-scale', color:'blue', textFn: function(c){ return 'Aamupunnitus kirjattu ' + c; } },
    { icon:'fa-regular fa-chart-simple', color:'purple', textFn: function(c){ return 'Edistyminen kirjattu ' + c; } },
    { icon:'fa-regular fa-bullseye', color:'cyan', textFn: function(c){ return 'Tavoite saavutettu ' + c; } },
    { icon:'fa-regular fa-bed', color:'purple', textFn: function(c){ return 'Unen laatu kirjattu ' + c; } },
    { icon:'fa-regular fa-glass-water', color:'cyan', textFn: function(c){ return 'Vedenjuontitavoite saavutettu ' + c; } },
    { icon:'fa-regular fa-circle-check', color:'green', textFn: function(c){ return 'Päivätavoite saavutettu ' + c; } },
    { icon:'fa-regular fa-medal', color:'yellow', textFn: function(c,rng){ var b=badges[Math.floor((rng?rng():Math.random())*badges.length)]; return b + ' -saavutus avattu ' + c; } },
    { icon:'fa-regular fa-trophy', color:'yellow', textFn: function(c){ return 'Viikkotavoite saavutettu ' + c; } },
    { icon:'fa-regular fa-star', color:'yellow', textFn: function(c){ return 'Uusi ennätys ' + c; } },
    { icon:'fa-regular fa-fire', color:'red', textFn: function(c,rng){ var b=badges[Math.floor((rng?rng():Math.random())*badges.length)]; return b + ' -saavutus avattu ' + c; } },
    { icon:'fa-regular fa-heart', color:'pink', textFn: function(){ return 'Kaveria tsempattu ryhmässä'; } },
    { icon:'fa-regular fa-message-dots', color:'orange', textFn: function(){ return 'Kysymys lähetetty valmentajalle'; } },
    { icon:'fa-regular fa-comments', color:'pink', textFn: function(c){ return 'Viesti ryhmäkeskusteluun ' + c; } },
    { icon:'fa-regular fa-flag-checkered', color:'green', textFn: function(c){ return 'Ensimmäinen valmennuspäivä alkoi ' + c; } },
    { icon:'fa-regular fa-handshake', color:'blue', textFn: function(c){ return 'Uusi jäsen liittyi valmennukseen ' + c; } },
    { icon:'fa-regular fa-face-smile', color:'pink', textFn: function(c){ return 'Fiilismittari kirjattu ' + c; } },
    { icon:'fa-regular fa-reply', color:'blue', textFn: function(){ return 'Sai vastauksen valmentajalta'; } },
    { icon:'fa-regular fa-bowl-food', color:'orange', textFn: function(c){ return '3 aamupalaa kirjattu putkeen ' + c; } }
  ];

  /* ─── Schema-arvojen lataus ─── */
  var SCHEMA_VALUES = {};
  try {
    var schemaEl = document.getElementById('ffPulssiSchema');
    if (schemaEl) SCHEMA_VALUES = JSON.parse(schemaEl.textContent);
  } catch(e) { console.warn('Pulssi: schema parse error', e); }

  /* ─── Koosteet (big data) ─── */
  function buildStatItems(rng) {
    function vary(base) {
      var variation = 1 + (rng() * 0.10 - 0.05);
      return Math.round(base * variation);
    }
    var S = SCHEMA_VALUES;
    return [
      { type:'stat', icon:'fa-regular fa-dumbbell', color:'blue',
        value: vary(S.treenit_7pv || 3502), suffix:'', desc:'treeniä kirjattu viimeisen 7 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-scale-balanced', color:'purple',
        value: vary(S.pudotus_7pv || 153), suffix:' kg', desc:'pudotettu yhteensä viimeisen 7 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-bowl-food', color:'orange',
        value: vary(S.ateriat_laihis_7pv || 1137), suffix:'', desc:'ateriaa kirjattu Laihis-ryhmässä viimeisen 7 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-comments', color:'pink',
        value: vary(S.viestit_7pv || 583), suffix:'', desc:'viestiä valmentajille viimeisen 7 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-trophy', color:'green',
        value: vary(S.tavoitteet_7pv || 631), suffix:'', desc:'tavoitetta saavutettu viimeisen 7 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-fire', color:'red',
        value: vary(S.treenit_30pv || 14238), suffix:'', desc:'treeniä kirjattu viimeisen 30 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-users', color:'cyan',
        value: vary(S.aktiiviset_24h || 1142), suffix:'', desc:'aktiivista käyttäjää viimeisen 24 tunnin aikana' },
      { type:'stat', icon:'fa-regular fa-chart-line-down', color:'green',
        value: S.pudotusvauhti || 0.7, suffix:' kg',
        desc:'valmennusten keskimääräinen pudotusvauhti viimeisen 7 päivän aikana',
        decimals:1, prefix:'-',
        trend: { direction:'up', label:'+' + (S.pudotusvauhti_trendi || 13) + '%', icon:'fa-regular fa-chart-line-up' } },
      { type:'stat', icon:'fa-regular fa-utensils', color:'orange',
        value: vary(S.ateriat_7pv || 9017), suffix:'', desc:'ateriaa kirjattu viimeisen 7 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-hand-holding-heart', color:'pink',
        value: S.onnistuneet_total || 100000, suffix:'+', desc:'suomalaista on onnistunut Fitfarmilla' },
      { type:'stat', icon:'fa-regular fa-person-running', color:'green',
        value: vary(S.treenitunnit_30pv || 4863), suffix:'', desc:'treenituntia kirjattu viimeisen 30 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-scale-balanced', color:'purple',
        value: vary(S.pudotus_30pv || 891), suffix:' kg', desc:'pudotettu viimeisen 30 päivän aikana' },
      { type:'stat', icon:'fa-regular fa-medal', color:'yellow',
        value: vary(S.saavutukset_24h || 347), suffix:'', desc:'saavutusta avattu viimeisen 24 tunnin aikana' }
    ];
  }

  /* ─── Deterministiset aikaleimat ─── */
  function generateTimestamp(rng) {
    var now = new Date();
    var hour = now.getHours();
    var maxMinutesAgo = hour < 8 ? 20 : hour < 12 ? 90 : hour < 16 ? 180 : hour < 20 ? 360 : 480;
    var minutesAgo = Math.floor(rng() * maxMinutesAgo);
    if(minutesAgo < 2) return 'juuri äsken';
    if(minutesAgo < 60) return minutesAgo + ' min sitten';
    var hours = Math.floor(minutesAgo / 60);
    if(hours === 1) return 'tunti sitten';
    return hours + ' t sitten';
  }

  /* ─── Päivän virran generointi ─── */
  function generateDayStream() {
    var seed = dateSeed();
    var rng = mulberry32(seed);

    var shuffledTemplates = eventTemplates.slice();
    for(var i = shuffledTemplates.length - 1; i > 0; i--){
      var j = Math.floor(rng() * (i + 1));
      var tmp = shuffledTemplates[i];
      shuffledTemplates[i] = shuffledTemplates[j];
      shuffledTemplates[j] = tmp;
    }
    var dayTemplates = shuffledTemplates.slice(0, 15);

    var shuffledCities = cities.slice();
    for(var i2 = shuffledCities.length - 1; i2 > 0; i2--){
      var j2 = Math.floor(rng() * (i2 + 1));
      var tmp2 = shuffledCities[i2];
      shuffledCities[i2] = shuffledCities[j2];
      shuffledCities[j2] = tmp2;
    }
    var dayCities = shuffledCities.slice(0, 15);

    var events = [];
    for(var k = 0; k < 15; k++){
      var tpl = dayTemplates[k];
      var city = dayCities[k].loc;
      events.push({
        type: 'event',
        icon: tpl.icon,
        color: tpl.color,
        text: tpl.textFn(city, rng)
      });
    }

    var stats = buildStatItems(rng);

    var stream = [];
    var ei = 0, si = 0;
    while(ei < events.length || si < stats.length) {
      if(ei < events.length) stream.push(events[ei++]);
      if(si < stats.length) stream.push(stats[si++]);
    }
    return stream;
  }

  /* ─── Renderöinti ─── */
  function init() {
    var stage = document.getElementById('ffPulssiStage');
    var updatedText = document.getElementById('ffPulssiUpdated');
    if (!stage) return;

    var stream = generateDayStream();
    var timeRng = mulberry32(dateSeed() + 9999);
    var currentIndex = -1;
    var currentEl = null;

    function formatNumber(n, decimals) {
      if(decimals) return n.toFixed(decimals).replace('.', ',');
      return n.toLocaleString('fi-FI');
    }

    function animateCount(el, target, suffix, prefix, decimals) {
      var duration = 1400;
      var start = performance.now();
      function tick(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = decimals ? (target * eased) : Math.round(target * eased);
        el.textContent = (prefix||'') + formatNumber(current, decimals) + (suffix||'');
        if(progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % stream.length;
      var data = stream[currentIndex];

      if(currentEl) {
        currentEl.classList.remove('active');
        currentEl.classList.add('exit');
        var old = currentEl;
        setTimeout(function(){ if(old.parentNode) old.parentNode.removeChild(old); }, 700);
      }

      var item = document.createElement('div');
      item.className = 'ff-pulssi__item';

      if(data.type === 'stat') {
        var trendHtml = '';
        if(data.trend) {
          trendHtml = '<div class="ff-pulssi__trend ff-pulssi__trend--' + data.trend.direction + '"><i class="' + data.trend.icon + '"></i> ' + data.trend.label + '</div>';
        }
        item.innerHTML =
          '<div class="ff-pulssi__icon ff-pulssi__icon--' + data.color + '"><i class="' + data.icon + '"></i></div>' +
          '<div class="ff-pulssi__big-value"></div>' +
          '<div class="ff-pulssi__desc">' + data.desc + '</div>' +
          trendHtml;
      } else {
        var timestamp = generateTimestamp(timeRng);
        item.innerHTML =
          '<div class="ff-pulssi__icon ff-pulssi__icon--' + data.color + '"><i class="' + data.icon + '"></i></div>' +
          '<div class="ff-pulssi__event-text">' + data.text + '</div>' +
          '<div class="ff-pulssi__meta"><i class="fa-regular fa-clock"></i> ' + timestamp + '</div>';
      }

      stage.appendChild(item);

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          item.classList.add('active');
          if(data.type === 'stat') {
            var valEl = item.querySelector('.ff-pulssi__big-value');
            animateCount(valEl, data.value, data.suffix, data.prefix, data.decimals);
          }
        });
      });

      currentEl = item;

      if(updatedText) {
        var now = new Date();
        var h = String(now.getHours()).padStart(2,'0');
        var m = String(now.getMinutes()).padStart(2,'0');
        var s = String(now.getSeconds()).padStart(2,'0');
        updatedText.textContent = 'Päivitetty ' + h + ':' + m + ':' + s;
      }
    }

    function scheduleNext() {
      var delay = 3500 + Math.random() * 2000;
      setTimeout(function() {
        showNext();
        scheduleNext();
      }, delay);
    }

    // Käynnistä kun elementti tulee näkyviin
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if(entry.isIntersecting) {
          observer.unobserve(entry.target);
          showNext();
          scheduleNext();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(stage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
